import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CTA from 'Src/components/buttons/CTA';
import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';
import { Check, CheckItem } from 'Src/feature/check/models';
import { UsedCurrentCheckItemButtons } from 'Src/feature/check-item/useCurrentCheckItemButtons';
import { routeParamValue } from 'Src/routes/params';
import useRoute from 'Src/routes/useRoute';

import styles from './CheckVoids.module.scss';

interface CheckVoidsProps {
  checkItemButtons: UsedCurrentCheckItemButtons;
}

const CheckVoids: FC<CheckVoidsProps> = ({ checkItemButtons }) => {
  const { t } = useTranslation();
  const { crumbs, navigate, route } = useRoute();
  const { activeCheck } = checkItemButtons;
  const voidedCheckItems = (activeCheck?.items || []).filter((item) => CheckItem.IsVoid(activeCheck as Check, item));

  if (voidedCheckItems && voidedCheckItems.length > 0) {
    return (
      <Flex horizontal justifyContent="center" alignItems="center" className={styles['root']}>
        <Copy color="textSecondary" value={t('check.labels.itemsVoided', { count: voidedCheckItems?.length })} />
        <CTA
          size="sm"
          onClick={() => navigate(crumbs.pos.check.detail.interpolate({
            checkId: activeCheck?.id,
            tabId: routeParamValue.checkActivity,
            itemSelect: route.params.active.itemSelect,
          }))}
          label={t('labels.view')}
        />
      </Flex>
    );
  } else return null;
};

export { CheckVoids };
